export default "__VITE_ASSET__C1oGf1qO__"